<script>
import StatsDataService from "@/services/StatsDataService";

let today = new Date().getFullYear();

export default {
  name: "ChartUsersAge",
  data() {
    return {
      filtersDates: {
        selected: '1M',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      },
      series:[],
      chartOptions: {
        chart: {
          id: 'users-age-gender',
          type: 'area',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'category',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        },
        annotations: {
          xaxis: [{
            x: String(today-35),
            borderColor: '#9ccc65',
            strokeDashArray: 3,
            label: {
              style: {
                color: '#111',
                background: '#9ccc65',
              },
              offsetY: -10,
              text: '35 '+this.$t("yo"),
            }
          },
          {
            x: String(today-50),
            borderColor: '#ffca28',
            strokeDashArray:3,
            label: {
              style: {
                color: '#111',
                background: '#ffca28',
              },
              offsetY: -10,
              text: '50 '+this.$t("yo")
            }
          },
          {
            x: String(today-70),
            borderColor: '#8d6e63',
            strokeDashArray: 3,
            label: {
              style: {
                color: '#fff',
                background: '#8d6e63',
              },
              offsetY: -10,
              text: '70 '+this.$t("yo")
            }
          }
          ]
        }
      },
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersAgeStats(params)
          .then(response => {
            const data = response.data;
            this.$refs.usersAgeChart.updateSeries([{
              name: this.$t("male"),
              data: data.male
            },{
              name: this.$t("female"),
              data: data.female
            }]);
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersAgeStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardUsersAge">
    <h5 class="card-title">Age/Year Distribution</h5>
    <b-form-radio-group
        v-model="filtersDates.selected"
        :options="filtersDates.options"
        button-variant="outline-secondary"
        size="sm"
        class="mt-1 mb-2"
        buttons
        @change="handleDateChange"
    ></b-form-radio-group>
    <apexchart
        ref="usersAgeChart"
        type="area"
        dir="ltr"
        height="350"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardUsersAge .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardUsersAge .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>